import React from "react";
import { twMerge } from "tailwind-merge";

/**
 * CustomButton - A gradient button with loading state
 * 
 * @param {string} buttonText - The text to display in the button
 * @param {boolean} loading - Whether the button is in a loading state
 * @param {function} onClick - The function to call when the button is clicked
 * @param {boolean} disabled - Whether the button is disabled
 * @param {string} className - Additional classes to apply to the button (can override all default styles)-width height font styles should be passed from here
 * @param {React.ReactNode} icon - Icon to display alongside the text
 * @param {string} iconPosition - Position of the icon ("left" or "right")
 * @param {string} type - Button type attribute
 * @param {object} props - Any additional props to pass to the button
 */
const CustomButton = ({
  buttonText = "Button",
  loading = false,
  onClick,
  disabled = false,
  className = "",
  icon,
  iconPosition = "left",
  type = "button",
  ...props
}) => {
  const customLoader = (
    <div className="w-6 h-6 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
  );
  
  return (
    <button
      onClick={onClick}
      type={type}
      disabled={disabled || loading}
      className={twMerge(
        `flex justify-center items-center py-3 w-full
        font-public-sans font-bold text-lg
        bg-gradient-to-t from-[#197AD0] from-[18.55%] to-[#52FAF0] to-[100%]
        hover:brightness-105
        rounded-md focus:outline-none focus:ring-2 
        focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-[#1E1E1E]
        transition-all duration-300 ease-in-out text-[#1E1E1E]`,
        (disabled || loading) ? "opacity-70 cursor-not-allowed" : "cursor-pointer",
        className
      )}
      {...props}
    >
      {loading ? (
        customLoader
      ) : (
        <>
          {icon && iconPosition === "left" && <span className="mr-2">{icon}</span>}
          {buttonText}
          {icon && iconPosition === "right" && <span className="ml-2">{icon}</span>}
        </>
      )}
    </button>
  );
};

export default CustomButton;